import poiPlaceholderThumbnail from '@/assets/images/placeholders/ske-small.png';
import poiPlaceholderDetail from '@/assets/images/placeholders/ske-big.png';

export const POI_PLACEHOLDER = {
    thumbnail: poiPlaceholderThumbnail,
    detail: poiPlaceholderDetail,
} as const;
